import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContentDocument } from '../types';
import { HorizontalHouseAd, type FeaturedMedia } from './lib/horizontal-house-ad';

export interface WPHouseAdProps extends Record<string, unknown> {
  id: string;
  headline: string;
  body: string;
  ctaText: string;
  ctaType: 'WEB_LINK' | 'AUTH_LINK';
  ctaUrl?: string;
  ctaAuthLink?: StructuredContentDocument;
  template?: string;
  featuredMedia?: FeaturedMedia;
}

export function WPHouseAd({ props }: NodeProps<WPHouseAdProps>) {
  if (!props.body) return null;

  const ctaProps =
    props.ctaType === 'AUTH_LINK'
      ? { ctaNode: <StructuredContentRenderer doc={props.ctaAuthLink} /> }
      : { ctaHref: props.ctaUrl };

  return (
    <div>
      <HorizontalHouseAd
        body={props.body}
        ctaText={props.ctaText}
        featuredMedia={props.featuredMedia}
        headline={props.headline}
        {...ctaProps}
      />
    </div>
  );
}
